import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Image, P } from "../../AbstractElements";
import { SampleCards, SamplePage } from "../../utils/Constant";
import { samplePageData } from "../../Data/OtherPage/OtherPage";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import CommonCardHeader from "../../CommonElements/CommonCardHeader/CommonCardHeader";
import { dynamicImage } from "../../Service";
const SamplePageContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={"Dashboard"} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card style={{ border: "4px solid #B0653C" }}>
              {/* <CommonCardHeader title={"Dashboard"} span={samplePageData} /> */}
              <CardBody className="p-0">
                <Image
                  className="img-fluid"
                  src={dynamicImage("dashboard.webp")}
                  alt="logo"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SamplePageContainer;
